import React, {useState, useEffect} from "react";
import MyPageCompanyCard from "../components/MyPageCompanyCard";
// import config from "../config/config";
// const API_URL = config.API_URL;

function HomeCompanyManage() {
  
  // const [basicInfo, setBasicInfo] = useState([]);
  // const [briefInfo, setBriefInfo] = useState([]);
  // const [detailInfo, setDetailInfo] = useState([]);
  // const [memberInfo, setMemberInfo] = useState([]);
  // const [loading, setLoading] = useState(true);

  // // API 호출 함수
  // const fetchData = async () => {
  //   try {
  //     const response = await fetch(`${API_URL}/api/startup/getStartupCard`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       credentials: "include"
  //     });

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const result = await response.json();
  //     console.log(result.value);

  //     if (result.result) {        
  //       setBasicInfo(result.value.startup_info);       
  //       setMemberInfo(result.value.member_info);
  //       setBriefInfo(result.value.perf_summary);
  //       setDetailInfo(result.value.perf_detail);        
  //     } else {
  //       console.error("데이터 가져오기 실패:", result.message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching user data:", error);
  //     // setError(error.message); // 에러 메시지 저장
  //   } finally {
  //     setLoading(false); // 데이터 로딩 완료
  //   }
  // };
  // useEffect(() => {
  //   fetchData();
  // }, []);

  return(
    <div style={{flex: 1, display: 'flex', flexDirection: "column"}}>
      {/* {loading ? (
        <p>Loading...</p>
      ) : ( */}
        <MyPageCompanyCard 
          // basicInfo={basicInfo} briefInfo ={briefInfo} detailInfo={detailInfo} memberInfo={memberInfo}
          />
      {/* )} */}
    </div>
  );
}

export default HomeCompanyManage;